import axios from "axios";
import AllRoutes from "../../nametitle/AllRoutes";
import { baseUrl } from "../../nametitle/dataUrl";


// Créer un compte 
export const CreateEmail = (email) => {
  var data = JSON.stringify({
    "email": email,
  });
  var config = {
    method: 'post',
    url: `${baseUrl.baseUrl}/api/v1/email-send/`,
    headers: {
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0',
      'Authorization': `Bearer ${baseUrl.token}`
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      alert("Email envoyé avec succès");
      //console.log(response);
    })
    .catch(function (error) {
      //console.log(error);
      alert("Email existe déja");
    });
}


// ************************************************ Bloquer acces au compte
export const StopEmail = (id) => {
  var data = JSON.stringify({
    "access": Boolean(false),
  });
  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/email-send/hide/${id}`,
    headers: {
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0',
      'Authorization': `Bearer ${baseUrl.token}`
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      //console.log(JSON.stringify(response.data));
      window.location.reload()
    })
    .catch(function (error) {
      //console.log(error);
    });
}


// Recupérer tout compte des membres
export const LoadAllEmail = (SetState) => {
  axios.get(`${baseUrl.baseUrl}/api/v1/email-send/get/all`, {
    headers: {
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0',
      'Authorization': `Bearer ${baseUrl.token}`
    }})
    .then(function (response) {
      //console.log(JSON.stringify(response.data));
      SetState(response.data.data);
    })
    .catch(function (error) {
      //console.log(error);
    });
}
